// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.el-aside{box-sizing:border-box;flex-shrink:0;overflow:auto;width:var(--el-aside-width,300px)}`, "",{"version":3,"sources":["webpack://./../../../node_modules/element-plus/theme-chalk/el-aside.css"],"names":[],"mappings":"AAAA,UAAU,qBAAqB,CAAC,aAAa,CAAC,aAAa,CAAC,iCAAiC","sourcesContent":[".el-aside{box-sizing:border-box;flex-shrink:0;overflow:auto;width:var(--el-aside-width,300px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
